

























































import {
  Vue, Component, Prop, Watch, Mixins, Emit,
} from 'vue-property-decorator'
import {
  both, includes, filter, sortBy, sortWith, prop, descend, ascend,
} from 'ramda'
import firebase from 'firebase'
import {
  update, field, collection, get, query, where, set, add,
} from 'typesaurus'
import dayjs from 'dayjs'
// import { vueVimeoPlayer } from 'vue-vimeo-player'
import {
  getModule,
} from 'vuex-module-decorators'
import { db } from '../../firebase/init'
import { DisplaySlideType, DisplayBoardType, SlideDetailsType } from '../../types'
import MainMixin from '../../mixins/MainMixin'
import EventBus from '../../event-bus'
import DisplayScheduler from './DisplayScheduler.vue'
import 'vue-croppa/dist/vue-croppa.css'
import { uploadImage, createSlide } from '../../helpers/display-functions'
import { DisplaySlideCollection, DisplaySlideDetails } from '../../helpers/collections'

const Croppa = require('vue-croppa')

// Filter Functions

@Component({
  components: {
    // vueVimeoPlayer,
  },
})

export default class NewSlide<T extends Vue> extends Mixins(MainMixin) {
  @Prop({ default: null }) activeBoard!: DisplayBoardType | null

  newImage: any = {}

  newSlide: DisplaySlideType = {
    name: '',
    active: true,
    transition: 'slide',
    type: 'image',
    landscape: this.activeBoard ? this.activeBoard.landscape : false,
    url: '',
    boards: [],
    created: new Date(),
    updated: new Date(),
    location: '',
    background: '#606060',
  }

  transitions = [
    { text: 'Fade', value: 'fade' },
    { text: 'Slide', value: 'slide' },
    { text: 'Bounce', value: 'bounce' },
    { text: 'Zoom', value: 'zoom' },
  ]

  videoId = ''

  showVideo = 'none'

  refreshVideo = false

  colorDialog = false

  videoKey = 0

  loading = false

  $refs: any

  get imageQuality () { // sizes: 384 : 216'
    if (this.newImage && this.newImage.imageSet) {
      let quality = 5
      if (!this.newSlide.landscape) {
        const newQuality = Math.max(this.newImage.naturalHeight / 1920 * 5, this.newImage.naturalHeight / 1080 * 5)
        quality = Math.min(quality, newQuality)
      }
      if (!this.newSlide.landscape) {
        const newQuality = Math.max(this.newImage.naturalHeight / 1080 * 5, this.newImage.naturalHeight / 1920 * 5)
        quality = Math.min(quality, newQuality)
      } return quality
    } return 5
  }

  get locationItems () {
    if (this.activeBoard && this.activeBoard.location === this.group) {
      return [{ text: 'Entire Company', value: this.group as string }]
    } return [{ text: 'Individual Store', value: this.location as string }, { text: 'Entire Company', value: this.group as string }]
  }

  resetNewSlide () {
    this.newSlide = {
      name: '',
      active: true,
      transition: 'slide',
      type: 'image',
      landscape: this.activeBoard ? this.activeBoard.landscape : false,
      url: '',
      created: new Date(),
      updated: new Date(),
      boards: [],
      location: '',
      background: '#606060',
    }
    this.newImage.remove()
    this.$refs.obs.reset()
  }

  async createNewSlide () {
    const valid = await this.$refs.obs.validate()
    if (!valid) return this.$toast.error('Error Creating Slide - Slide Not Saved')
    this.loading = true
    try {
      await createSlide(this.newSlide, this.newImage, this.group, this.activeBoard ? this.activeBoard.id : '', this.activeBoard ? this.activeBoard.startHour : 0)
      this.loading = false
      this.resetNewSlide()
      this.$toast.success('Slide Successfully Added!')
      return this.activeBoard ? this.display('boards', 'singleBoard', true) : true
    } catch (e) {
      this.loading = false
      return this.$toast.error('Error Adding New Slide - Slide Has Not Been Created')
    }
  }

  @Emit()
  display (x: string, y: string, force: boolean = false) {
    return [x, y, force]
  }

  created () {
    this.newSlide.location = this.locationItems[0].value
  }
}

